<template>
  <div class="withdraw-card">
    <div class="withdrap-box">
      <div class="btn-setup btn" @click="settleSetClick">
        <img src="@/assets/images/icon_setup.png" />
        <span>{{$vi18n('$i18n# 结算设置 #i18n$')}}</span>
      </div>
      <div class="card-wrap">
        <div class="take-out-box" v-for="(card, index) in cardArr" :key="index">
          <div class="card-title-help">
            <p class="title">{{ card.type | regroupMoneyType }}</p>
            <el-tooltip placement="top" popper-class="atooltip">
              <img src="@/assets/images/icon_help.png" />
              <p slot="content" style="font-size: 16px">
                {{ card.type | regroupMoneyType
                }}{{ $vi18n('$i18n# 的提现时间为：每月{day_start}-{day_end}日 #i18n$', {day_start: card.day_start, day_end: card.day_end }) }}
              </p>
            </el-tooltip>
          </div>
          <p class="number">
            {{ card.num | regroupComma(card.type) }}
          </p>
          <div
            class="btn-take btn"
            :class="{
              'btn-forbid':
                currentDate > card.day_end ||
                currentDate < card.day_start ||
                card.had_order,
            }"
            @click="openWithdrawForm(card)"
          >
            {{$vi18n('$i18n# 提现 #i18n$')}}
          </div>
        </div>
      </div>
      <div class="explain-box">
        <p>1.{{ $vi18n('$i18n# 提现要求 #i18n$')}}：{{$vi18n('$i18n# 成功绑定银行卡 #i18n$')}}</p>
        <p>
          2.
          {{$vi18n('$i18n# 提现时间 #i18n$')}}：{{$vi18n('$i18n# 广告收入、迷你点、奖金的提现时间为每月5日-10日，贡献点、迷你豆的提现时间为每月15日-20日，请在对应的时间内进行提现操作 #i18n$')}}
        </p>
        <p>
          3. {{$vi18n('$i18n# 提现到账 #i18n$')}}：{{$vi18n('$i18n# 个人用户到账金额为平台代扣代征税的税后金额，详情请查看 #i18n$')}}<a
            class="detail-explain btn"
            href="https://mnweb.mini1.cn/activity/docs/settlement_proto_20210521.html"
            target="_blank"
            >《{{$vi18n('$i18n# 收益结算说明 #i18n$')}}》</a
          >
        </p>
      </div>
    </div>
    <!-- <DialogForm
      :withdrawInfo="withdrawInfo"
      :showWithdrawForm="showWithdrawForm"
      @closeWithdrawForm="closeWithdrawForm"
    ></DialogForm> -->
  </div>
</template>

<script>
import { errorTip } from '@/utils/index';
// import DialogForm from '../withdraw/formDialog';
// import newWithdrawCard from './newWithdrawCard.vue';
import { getSettlementOverview } from '@/api/income';
import { mapState } from 'vuex';
import { $vi18n } from '@/utils/i18n.js';
export default {
  name: 'withdrawCard',
  components: {},
  computed: {
    ...mapState(['developerInfo', 'bankInfo']),
  },
  data() {
    return {
      currentDate: new Date().getDate(),
      withdrawInfo: {},
      showWithdrawForm: false,
      formLabelWidth: '120px',
      tipTxt: '',
      cardArr: [],
      vid: 1,
    };
  },

  filters: {
    regroupMoneyType(type) {
      let moneyTypeTxt = '';
      switch (type) {
        case 1:
          moneyTypeTxt = $vi18n('$i18n# 贡献点 #i18n$');
          break;
        case 2:
          moneyTypeTxt = $vi18n('$i18n# 迷你豆 #i18n$');
          break;
        case 3:
          moneyTypeTxt = $vi18n('$i18n# 广告收入 #i18n$');
          break;
        case 4:
          moneyTypeTxt = $vi18n('$i18n# 迷你点 #i18n$');
          break;
        case 5:
          moneyTypeTxt = $vi18n('$i18n# 其他收入 #i18n$');
          break;
        default:
          break;
      }
      return moneyTypeTxt;
    },
    regroupComma(val, type) {
      if (val.toString().includes('.')) {
        let reg = /(\d)(?=(\d{3})+\.)/g;
        let point = '';
        type == 1 ? (point = 3) : (point = 2);
        return val.toFixed(point).toString().replace(reg, '$1,');
      } else {
        let reg = /(\d)(?=(?:\d{3})+$)/g;
        return val.toString().replace(reg, '$1,');
      }
    },
  },
  mounted() {
    this.fetchSettlementOverview();
  },
  methods: {
    settleSetClick() {
      //$vi18n('$i1# 结算设置点击埋点 #i18n$')
      this.$log('settlement_setting_click', 85434, { v7: 1 });
      this.$router.push({ name: 'settlementSet' });
    },
    async fetchSettlementOverview() {
      try {
        const res = await getSettlementOverview({ dtype: 1 });
        // $vi18n('$in# 需求排序 #i18n$')：3,1,4,2,5
        let { list } = res.data;
        let newList = [];
        const sortRules = [3, 1, 4, 2, 5];
        if (list && list.length) {
          sortRules.forEach(num => {
            const item = list.find(item => item.type === num);
            newList.push({ ...item });
          });
        }
        this.cardArr = newList;
      } catch (error) {
        console.log(error);
      }
    },
    openWithdrawForm(card) {
      //$vi18n('$i# 货币提现点击曝光 #i18n$')
      switch (card.type) {
        case 3:
          this.vid = 1;
          break;
        case 1:
          this.vid = 2;
          break;
        case 4:
          this.vid = 3;
          break;
        case 2:
          this.vid = 4;
          break;
        case 5:
          this.vid = 5;
          break;
        default:
          break;
      }
      this.$log('currency_withdrawal_click', 85432, { v7: 1, v8: this.vid });
      const { state } = this.developerInfo;
      if (state == 2) {
        errorTip($vi18n('$i18n# 账号异常，暂无法使用提现功能 #i18n$'));
      } else if (!this.bankInfo.bank_card && card.type != 2) {
        // $vi18n('$i迷你豆不需要绑定银行卡 #i18n$')
        errorTip($vi18n('$i18n# 您未绑定银行卡，请进行绑定后再申请提现 #i18n$'));
      } else if (state == 0 || state == 3) {
        errorTip($vi18n('$i18n# 您未认证成为开发者，请认证后再申请提现 #i18n$'));
      } else if (
        this.currentDate > card.day_end ||
        this.currentDate < card.day_start
      ) {
        errorTip(
          $vi18n('$i18n# 当前不可提现，请于每月{card.day_start}-{card.day_end}日发起提现申请 #i18n$', { day_start: card.day_start, day_end: card.day_end }),
        );
      } else if (card.had_order) {
        errorTip($vi18n('$i18n# 提现订单进行中，暂不支持提现 #i18n$'));
      } else if (card.num < card.min) {
        errorTip(
          `${this.$options.filters.regroupMoneyType(card.type)}${$vi18n('$i18n# 暂未达到提现要求 #i18n$')}`,
        );
      } else {
        this.showWithdrawForm = true;
        this.withdrawInfo = card;
      }
    },
    closeWithdrawForm(val, opt) {
      this.showWithdrawForm = val;
      if (opt == 'refresh') {
        this.fetchSettlementOverview();
        this.$emit('refreshTable', true);
      }
    },
  },
};
</script>

<style lang="scss">
$--color-primary: #fd9b21;

.withdraw-card {
  .btn-setup {
    float: right;
    margin: -10px 0 16px;
    display: flex;
    align-items: center;
    font-size: 16px;
    img {
      margin-right: 5px;
    }
    &:hover {
      color: $--color-primary;
    }
  }
  .card-wrap {
    margin: 22px 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .take-out-box {
      width: 186px;
      height: 150px;
      background: #fafafa;
      padding: 14px 0 24px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      font-size: 16px;
      position: relative;
      .card-title-help {
        display: flex;
        align-items: center;
      }
      img {
        width: 10px;
        height: 10px;
        margin-left: 8px;
      }
      .number {
        color: $--color-primary;
        font-size: 24px;
      }
      .btn-take {
        width: 90px;
        height: 32px;
        color: #fff;
        background: $--color-primary;
        text-align: center;
        line-height: 32px;
        border-radius: 8px;
      }
    }
  }
  .explain-box {
    color: #8c8c8c;
    .detail-explain {
      color: #2b6ddf;
      margin-left: 5px;
    }
  }
  .btn {
    cursor: pointer;
    &:hover {
      filter: brightness(105%);
    }
  }
  .btn-forbid {
    background: #d9d9d9 !important;
    &:hover {
      filter: brightness(100%);
    }
  }
}
/*$vi18n('$i18n# 修改 #i18n$')tooltip$vi18n('$i18n# 的背景颜色 #i18n$')*/
.el-tooltip__popper {
  background-color: #000 !important;
  opacity: 0.55;
}
/*$vi18n('$i18n# 修改 #i18n$')tooltip$vi18n('$i18n# 的箭头颜色 #i18n$')*/
.el-tooltip__popper[x-placement^='top'] .popper__arrow::after {
  border-top-color: #000 !important;
}
.el-tooltip__popper[x-placement^='top'] .popper__arrow {
  border-top-color: #000 !important;
}
</style>
